import React from 'react'
const Footer = () => {
    return ( 
        <div>

            <nav className="navbar d-flex align-items-center" style={{backgroundColor:'#f8f9fa'}}>
                <div className="container-fluid d-flex justify-content-center">
                    <a className="h6 text-decoration-none" href="https://nec.edu.in/">© National Engineering College 2022 | All rights reserved.</a>
                </div>
            </nav>
        </div>
     );
}
 
export default Footer;